import { SortBy } from "@/domains/manual-cl-page/manual-cl-page-store"
import { ILiquidityPool } from "@/domains/pools"
import { poolSearch } from "@/domains/pools/pool-search"
import { TableProcessor } from "@/domains/table-processor"

export const manualClProcessor = (pools: Array<ILiquidityPool>, search: string | null, sortBy: SortBy) => {
  const processed = TableProcessor({
    rows: pools,
    filters: {
      static: [
        {
          name: "search text",
          field: "*",
          filterFunction: (row: ILiquidityPool) => {
            return poolSearch(row, search)
          },
        },
      ],
      dynamic: [],
    },
    sort: sortBy,
  })

  return processed
}
